import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import BreadcrumbsPortal from '../../util/BreadcrumbsPortal';
const ClaimGroupBreadcrumbLinks = _ref => {
  let {
    claimGroup
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(state => state.auth.user);
  return /*#__PURE__*/React.createElement(BreadcrumbsPortal, null, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(user.account_type)
    }
  }, t('home')), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(user.account_type, "/companies")
    }
  }, t('companies')), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(user.account_type, "/companies/").concat(claimGroup.company_id, "/master")
    }
  }, claimGroup.company.name), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    active: true
  }, claimGroup.name)));
};
export default ClaimGroupBreadcrumbLinks;